import { render } from "./EditClientDialog.vue?vue&type=template&id=306948c2"
import script from "./EditClientDialog.vue?vue&type=script&lang=js"
export * from "./EditClientDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__